import { ChildEnrollmentFormFields, EnrollmentAdditionalCriteriaField } from 'types';
import { CreateChildEnrollmentDTO } from 'types/enrollment/enrollment';
import { enrollmentAdditionalCriteriaFieldsArray } from 'consts/enrollment/enrollmentAdditionalCriteriaFields';
import { parseDayjsDateIntoString } from 'utils/parsers/dateTime/parseDayjsDateIntoString';

export const parseChildEnrollmentFormFieldsIntoCreateChildEnrollmentDTO: (
    childEnrollmentFormFields: ChildEnrollmentFormFields,
) => CreateChildEnrollmentDTO = (childEnrollmentFormFields) => {
    const {
        enrollmentChildData,
        enrollmentParentData,
        enrollmentChildAddressData,
        additionalConditions,
    } = childEnrollmentFormFields;
    const {
        sex,
        birthPlace,
        birthDate,
        lastName: childLastName,
        firstName: childFirstName,
        peselNumber,
    } = enrollmentChildData;
    const {
        lastName: parentLastName,
        firstName: parentFirstName,
        phoneNumber,
        email,
    } = enrollmentParentData;

    const parsedAdditionalCriteria = enrollmentAdditionalCriteriaFieldsArray.reduce(
        (additionalCriteriaResult, additionalCriteriaField) => {
            // eslint-disable-next-line no-param-reassign
            additionalCriteriaResult[additionalCriteriaField] =
                !!additionalConditions?.includes(additionalCriteriaField);
            return additionalCriteriaResult;
        },
        {} as { [key in EnrollmentAdditionalCriteriaField]: boolean },
    );

    return {
        child: {
            sex,
            birthPlace,
            birthDate: parseDayjsDateIntoString(birthDate, 'YYYY-MM-DD'),
            firstName: childFirstName,
            lastName: childLastName,
            pesel: peselNumber,
        },
        address: enrollmentChildAddressData,
        parent: { email, phoneNumber, firstName: parentFirstName, lastName: parentLastName },
        additionalCriteria: parsedAdditionalCriteria,
    };
};
